import MainLayout from "layout/MainLayout";
import { Outlet } from "react-router-dom";

const MerchantLayout = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default MerchantLayout;
